import { render, staticRenderFns } from "./rules-management.vue?vue&type=template&id=3b3a999e&"
import script from "./rules-management.vue?vue&type=script&lang=js&"
export * from "./rules-management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports